/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit UseNewDriverAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'
import TysiaToggleText from 'DesignSystem/TysiaToggle/TysiaToggleText/index'



/** @type {import('Simple/types.js').View} */
export default function UseNewDriverAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/ImportFromDevices/Content/ModalBody/UseNewDriverAction"
  
}) {
let dwtUseNewDriversValueData = fromData.useDataValue({ viewPath,
context: 'dwt',
path: 'useNewDrivers',
})
let dwtToggleUseNewDriversValueData = fromData.useDataValue({ viewPath,
context: 'dwt',
path: 'toggleUseNewDrivers',
})
  return (<React.Fragment
>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 marginTop={0}
 data="dwt.useNewDrivers"
 value={dwtUseNewDriversValueData}
 data="dwt.toggleUseNewDrivers"
 onClick={dwtToggleUseNewDriversValueData}
>
{childProps => (
<React.Fragment>
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
/>
<TysiaToggleText
{...childProps}
  viewPath={`${viewPath}/TysiaToggleText`}
 marginLeft={0}
 weight="normal"
 text="Only use new drivers"
/>
</React.Fragment>
)}
</TysiaToggle>
{children}
</React.Fragment>)
}